import React from "react";
import PropTypes from "prop-types";
import AppConfig from "../../../../config/AppConfig";
import AuthAPI from "../../../../api/AuthAPI";
import IframeModal from "../../../../components/Modals/IframeModal";

export class UserEventGuestPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //
        }
    }

    render() {
        return (
            <IframeModal
                onDismiss={this.props.onDismiss}
                title={"Riserva il tuo posto"}
                src={`${AppConfig.webServerUrl}/api/user/module-events/guest-view/app?event_code=${this.props.eventLink}&token=${AuthAPI.currentUser.accessToken}`}
            />
        );
    }
}

UserEventGuestPage.propTypes = {
    onDismiss: PropTypes.func,
    eventLink: PropTypes.string
}